export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvContent.vue?vue&type=template&id=63bcd47c&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvContent.vue?vue&type=template&id=63bcd47c&lang=pug&
// module id = 87
// module chunks = 0 1